module.exports = __webpack_public_path__ + "static/media/erp-business-12.94deadc4.gif";